
// import { alertInstance } from "./services/eventEmmiter";
import { alertInstance } from "../../alert";
import { useEffect, useState } from "react";
import TaskService from "../../../services/TaskService";
import Button from "../../buttons/Button";
import AssessmentMultipleChoiceQuestion from "../screens/AssessmentMultipleChoiceQuestion";

import InstructionScreen from "../screens/Instruction";
import { ConfirmSubmitPage } from "./ConfirmSubmitPage";
import SaveAsDraftModal from "./SaveAsDraftModal";
import ScoreCard from "./ScoreCard";
import { Box, Text } from "@radix-ui/themes";
import MultipleChoiceQuestion from "../screens/MultiChoiceQuestionProps";
import SingleChoiceQuestion from "../screens/SingleChoiceQuestion";
import { produce } from "immer";
import Wizard from "./Wizard";
import { SubmitSuccessScreen } from "./SubmitSuccessPage";

enum Step {
  Instruction,
  Assessment,
  ConfirmSubmit,
  Result,
  MandatoryRemaining,
  ScoreCard,
  SubmitSuccess
}

const Test = ({ task }: { task: any }) => {
  console.log("task", task);
  const [questions, setQuestions] = useState<any>(
    task.assessment.questions.assessmentDetails.questionDetails
  );
  const [step, setStep] = useState<Step>(Step.Instruction);
  const taskService = new TaskService();


  const handleSingleChoice = (option: any, index: number) => {
    setQuestions(
      produce((questions: any) => {
        questions[index].answer = questions[index].answerOptions.map(
          (el: any, index: number) => {
            if (index == option.answerId) {
              el.isAnswer = true;
            } else el.isAnswer = false;
            return el;
          }
        );
      })
    );
  };

  useEffect(() => {
    console.log("questions", questions);
  }, [questions]);

  const calculateTotalMarks = () => {
    console.log("questions", questions);
    let userMarks = 0;
    // Iterate through each question in task.assessment.questions.assessmentDetails.questionDetails
    task.assessment.questions.assessmentDetails.questionDetails.forEach((taskQuestion: any, index: number) => {
      // Find the corresponding user question in the questions array
      const userQuestion = questions.find((q: any) => q.question === taskQuestion.question);
      if (userQuestion) {
        // Get the correct answer from taskQuestion.answerOptions
        const correctAnswer = taskQuestion.answerOptions.find((option: any) => option.rightAnswer === true);
        // Get the user's selected answer from userQuestion.answer
        const userAnswer = userQuestion.answer.find((answer: any) => answer.isAnswer === true);
        // Check if the user's selected answer matches the correct answer
        if (
          correctAnswer &&
          userAnswer &&
          correctAnswer.answerOption === userAnswer.answerOption &&
          correctAnswer.rightAnswer === userAnswer.rightAnswer
        ) {
          userMarks += Number(taskQuestion.marks);
        }
      }
    });

    return userMarks;
  };

  const findingScoreResult = (score: number, task) => {
    const totalMarks = Number(task.assessment.questions.assessmentDetails.totalScoreOrMarks);
    const minimumMarks = Number(task.assessment.questions.assessmentDetails.minimumMarksDetails);
    if (score >= minimumMarks) {
      return "Passed";
    } else if (score < minimumMarks) {
      return "Failed";
    }
  };

  const updateMultiChoiceValue = (option: any, index: number) => {
    setQuestions(
      produce((questions: any) => {
        questions[index].answerOptions = questions[index].answerOptions.map(
          (el: any, i: number) => {
            if (i === option.answerId) {
              return { ...el, isAnswer: !el.isAnswer }; 
            }
            console.log("el1", el);
            
            return el;
          }
        );
        questions[index].answer = questions[index].answerOptions;
      })
    );
  };

  const validateTest = () => {
    let checkMandatoryQuestions = [];
    questions.map((item: any) => {
      if (item.Mandatory && !item.answer.some((item: any) => item.isAnswer === true))
        checkMandatoryQuestions.push(item.id);
    });
    return checkMandatoryQuestions.length ? false : true;
  };

  const handleSubmit = async (taskId = task?.id) => {
    if (!validateTest()) {
      setStep(Step.MandatoryRemaining);
    } else {
      const data = { ans: [...Object.values(questions)] };
      const res: any = await taskService.submit(taskId, data);
      if (res.code === 200) {
        setStep(Step.ScoreCard);
      } else {
        alertInstance.emit("showAlert", {
          type: "error",
          heading: "Something Went Wrong",
          buttonText: "ok",
        });
      }
    }
  };

  return (
    <div>
      {step == Step.Instruction && (
        <Box>
          <Text className="font-bold text-app-blue mb-2">
            Total number of questions: {questions.length}
          </Text>
          <div className="border-b-2 border-app-blue mb-2"></div>
          <Text className="block font-medium italic">Instruction:</Text>
          <Text>{task.description}</Text>
          <Box className="mt-4">
            <button
              className="btn-primary"
              onClick={() => {
                setStep(Step.Assessment);
              }}
            >
              Start Test
            </button>
          </Box>
        </Box>
      )}

      {step === Step.Assessment && (
        <Wizard
          handleSubmit={() => handleSubmit(task.id)}
          // handleSubmit={() => handleSubmit(task, assessmentState)}
          heading={""}
          steps={questions.map(
            (item: any, index: number) => {
              if (item.questionType.toLowerCase() === "single choice")
                return (
                  <SingleChoiceQuestion
                    key={index}
                    onChoice={handleSingleChoice}
                    question={item.question}
                    options={item.answerOptions.map((el: any, key: number) => ({
                      answerId: key,
                      value: el.answerOption,
                      isAnswer: !!el.isAnswer,
                      isRightAnswer: el.rightAnswer,
                    }))}
                    isMandatory={false}
                    index={index}
                  />
                );
              if (item.questionType.toLowerCase() === "multiple choice")
                return (
                  <MultipleChoiceQuestion
                    key={index}
                    question={item.question}
                    options={item.answerOptions.map((el: any, key: number) => ({
                      answerId: key,
                      value: el.answerOption,
                      isAnswer: !!el.isAnswer,
                      isRightAnswer: el.rightAnswer,
                    }))}
                    index={index}
                    updateAnswers={updateMultiChoiceValue}
                    isMandatory={item.Mandatory}
                    questionId={item.id}
                    surveyState={task}
                  />
                );
            }
          )}
        ></Wizard>
      )}

      {/* {step === Step.ConfirmSubmit && (<></>
        <ConfirmSubmitPage
          onSubmit={() => handleSubmit(task)}
          setStep={setStep}
          prevStep={Step.Assessment}
        />
      )} */}

      {step === Step.Result && (
        <SubmitSuccessScreen
          message={
            task.assessmentType === "test"
              ? "Thank you for completing the test"
              : "Thank you for completing the assessment"
          }
        />
      )}

      {step === Step.MandatoryRemaining && (
        <div className="flex flex-col gap-5 px-[1.5%]">
          <p>
            You have missed to respond to mandatory question/s. please go back
            and respond to all mandatory question to complete this Assessment.
          </p>
          <Button
            styles="border-2  border-app-blue outline-none py-2 w-32 bg-gradient-to-br from-purple-900  to-purple-500 text-white"
            onClick={() => setStep(Step.Assessment)}
          >
            Ok
          </Button>
        </div>
      )}

      {Step.ScoreCard === step && (
        <>
          <ScoreCard
            handleSubmit={() => setStep(Step.Result)}
            assessmentType={task.assessmentType}
            score={calculateTotalMarks()}
            totalScore={
              task?.assessment?.questions?.assessmentDetails?.totalScoreOrMarks ?
                Number(task?.assessment?.questions?.assessmentDetails?.totalScoreOrMarks) || 0 : 0
            }
            minimumScore={
              task?.assessment?.questions?.assessmentDetails?.minimumMarksDetails ?
                task?.assessment?.questions?.assessmentDetails?.minimumMarksDetails || 0 : 0
            }
            findingResult={findingScoreResult(
              calculateTotalMarks(),
              task
            )}
          />
          {/* <div className="flex space-x-6 p-4 border-t-2 ">
            <SaveAsDraftModal
              buttonName="Finish"
              dialogContent="Submitted Successfully"
            />
            {calculateTotalMarks(answerData) <
              localAssessmentDetail.minimumMarksDetails &&
              localAssessmentDetail.reAttempt === "yes" &&
              showButton && (
                <Button
                  onClick={() =>
                    reAttemptTest(localAssessmentDetail.reAttemptDetails)
                  }
                  styles="border-2 border-app-blue outline-none py-2"
                >
                  Re-Attempt Test
                </Button>
              )}
          </div> */}
        </>
      )}
    </div>
  );
};

export default Test;
